import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../../components/Sparklines';

export const COLUMNS = (t) => [
    {
        label: t('search.keyword_clusters_detail.keywords.keyword'),
        key: 'keyword',
        data: 'keyword',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong>
                    <a
                        href={`/domains/${
                            window.info.id
                        }/gsc-reports/keywords/keyword?keyword=${encodeURIComponent(data)}`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data}
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.trend'),
        key: 'sparkline',
        data: 'sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';

            return (
                <Sparkline
                    dataL={item.clicksL}
                    labels={item.start_dateL.map((x) => x.value)}
                    keyName="Clicks"
                />
            );
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.trend'),
        key: 'impressions_sparkline',
        data: 'impressions_sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';

            return (
                <Sparkline
                    dataL={item.impressionsL}
                    labels={item.start_dateL.map((x) => x.value)}
                    keyName="Impressions"
                />
            );
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.avgPosition'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.weekly_urls'),
        key: 'weekly_urls',
        data: 'weekly_urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.keyword_clusters_detail.keywords.avgCTR'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
];
